import React from "react";
import { useLocation } from "react-router-dom";
import MPMCModuleSubtopic from "../MPMCModuleSubtopic";

const ARM_Architecture = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <MPMCModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="ARM Architecture and Processor Fundamentals"
      videos={[
        "https://www.youtube.com/embed/JPfG0UQd3x4", // Introduction to ARM architecture
        "https://www.youtube.com/embed/-7D_PZhb7Qc", // Registers Organization
        "https://www.youtube.com/embed/-Hoo-CV19P8", // ARM registers explained
        "https://www.youtube.com/embed/9XenFAha88o", // Additional ARM video
        "https://www.youtube.com/embed/XbVONAOYKTw", // ARM architecture video from playlist
        "https://www.youtube.com/embed/VtwaY19RZZw", // ARM processor modes
        "https://www.youtube.com/embed/0kC2-hhdvto", // Additional ARM concepts
      ]}
      takeaways={[
        {
          text: "This module is entirely theoretical with emphasis on understanding ARM architecture fundamentals.",
        },
        {
          text: "ARM architecture and processor modes are likely to appear as 7 or 10 mark questions in exams.",
        },
        {
          text: "Topics like registers, pipelining, vector table, and exception handling typically appear as supplementary questions.",
        },
        {
          text: "Focus on understanding the differences between different processor states and between 3-stage and 5-stage pipelining architectures.",
        },
        {
          text: "Learn all block diagrams thoroughly, including data flow models, pipeline structures, and register organization.",
        },
      ]}
      questions={[
        "Describe the ARM dataflow model and registers with a block diagram and explain the operations of individual blocks.",
        "Explain the 3-stage pipelining architecture of ARM7 and the 5-stage pipelining architecture of ARM9 processors with relevant diagrams depicting their pipeline structures.",
        "A pipeline is a mechanism a RISC processor uses to execute Instructions. Explain with a neat diagram the three-stage pipeline that is incorporated into the ARM 7 processor.",
        "With a neat diagram, explain the data flow between the ALU and the Barrel shifter in the ARM processor.",
        "With a neat diagram, explain the data flow between the ALU and the Barrel Shifter in the ARM processor.",
        "Discuss the different processor modes of ARM processors with neat sketches describing their register banks.",
        "Explain with a neat diagram the three stages and five stages pipeline that is incorporated in the ARM processors.",
        "The ARM core uses RISC architecture. RISC is a design philosophy aimed at delivering simple but powerful instructions. Describe about the four major design rules on which the RISC philosophy is implemented.",
      ]}
      exampleVideos={[]} // No extra example videos
    />
  );
}

export default ARM_Architecture;
